import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

/**
 * Amber warning badge rendered on workflow nodes imported with unresolved
 * references (e.g., `agent_id` not in the destination org). Consumed by the
 * 4 custom node types (llm/code/http/agent). See 03-UI-SPEC §Needs-attention.
 */
export function NeedsAttentionBadge() {
  const { t } = useTranslation('workflows')
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          aria-label={t('lifecycle.needsAttention.badge')}
          data-testid="needs-attention-badge"
          className="inline-flex items-center justify-center h-5 w-5 rounded-sm bg-amber-500/20 text-amber-400"
        >
          <AlertTriangle className="h-3.5 w-3.5" />
        </span>
      </TooltipTrigger>
      <TooltipContent>{t('lifecycle.needsAttention.tooltip')}</TooltipContent>
    </Tooltip>
  )
}
